'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MOL = {
  ADD_INIT: 'MOL_ADD_INIT',
  ADD_DONE: 'MOL_ADD_DONE',
  ADD_FAIL: 'MOL_ADD_FAIL',
  CONVERT_DONE: 'MOL_CONVERT_DONE',
  CONVERT_FAIL: 'MOL_CONVERT_FAIL'
};

var FILE = {
  ADD_INIT: 'FILE_ADD_INIT',
  ADD_DONE: 'FILE_ADD_DONE',
  ADD_FAIL: 'FILE_ADD_FAIL',
  CONVERT_DONE: 'FILE_CONVERT_DONE',
  CONVERT_FAIL: 'FILE_CONVERT_FAIL',
  SAVE_INIT: 'FILE_SAVE_INIT',
  SAVE_DONE: 'FILE_SAVE_DONE',
  REFRESH_INIT: 'FILE_REFRESH_INIT'
};

var NOTICE = {
  MANUAL_CLEAR: 'NOTICE_MANUAL_CLEAR'
};

var PREDICT = {
  PREDICT_INIT: 'PREDICT_PREDICT_INIT',
  PREDICT_DONE: 'PREDICT_PREDICT_DONE',
  PREDICT_FAIL: 'PREDICT_PREDICT_FAIL',
  PREDICT_TO_WRITE_INIT: 'PREDICT_PREDICT_TO_WRITE_INIT',
  PREDICT_TO_WRITE_DONE: 'PREDICT_PREDICT_TO_WRITE_DONE',
  ADD_PRED_JSON_INIT: 'PREDICT_ADD_PRED_JSON_INIT'
};

var FORM = {
  SUBMIT: 'FORM_SUBMIT'
};

var DESC = {
  UPDATE: 'DESC_UPDATE'
};

var JCAMP = {
  ADD_OTHERS_INIT: 'JCAMP_ADD_OTHERS_INIT',
  ADD_OTHERS_RDC: 'JCAMP_ADD_OTHERS_RDC'
};

exports.MOL = MOL;
exports.FILE = FILE;
exports.NOTICE = NOTICE;
exports.PREDICT = PREDICT;
exports.FORM = FORM;
exports.DESC = DESC;
exports.JCAMP = JCAMP;